module.exports = __webpack_public_path__ + "img/volume.8a03ac9a.svg";